import { DecryptedItemMutator } from '@standardnotes/models';
export class ItemsKeyMutator extends DecryptedItemMutator {
    set isDefault(isDefault) {
        this.mutableContent.isDefault = isDefault;
    }
}
